import { Moon, Sun, Sunrise, Sunset, type LucideIcon } from "lucide-react";
import type { SkyTone } from "@/data/sky";

const SKY_TONE_ICONS: Record<SkyTone, LucideIcon> = {
  sunrise: Sunrise,
  sun: Sun,
  sunset: Sunset,
  moon: Moon,
};

export function SkyToneIcon({ tone }: { tone: SkyTone }) {
  const Icon = SKY_TONE_ICONS[tone];
  return <Icon aria-hidden="true" focusable="false" strokeWidth={1.7} />;
}
